import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/** Schedule form */
import { createRef } from "preact";
import { CurrentTask } from "./CurrentTask";
import { useState } from "preact/hooks";
export const Scheduler = (props) => {
    const typ = createRef();
    const date = createRef();
    const time = createRef();
    const [didSend, setDidSend] = useState(false);
    return (_jsxs("article", { className: "scheduler-form", children: [_jsx("h1", { children: "Schedule" }), _jsx(CurrentTask, {}), _jsxs("form", { className: "flow", onSubmit: (ev) => {
                    ev.preventDefault();
                    setDidSend(true);
                    props.onComplete({
                        date: date.current.value,
                        type: typ.current.value,
                        time: time.current.value,
                    });
                }, children: [_jsxs("div", { children: [_jsx("label", { for: "sched-type", children: "Type" }), _jsxs("select", { id: "sched-type", ref: typ, children: [_jsx("option", { children: "Final Exam" }), _jsx("option", { children: "Midterm" }), _jsx("option", { children: "Meeting" })] })] }), _jsxs("div", { children: [_jsx("label", { for: "sched-date", children: "Date" }), _jsx("input", { id: "sched-date", type: "date", ref: date })] }), _jsxs("div", { children: [_jsx("label", { for: "sched-time", children: "Time" }), _jsx("input", { id: "sched-time", type: "time", ref: time })] }), _jsx("input", { type: "submit", value: "Schedule" })] }), didSend ? _jsx("p", { children: "Scheduled!" }) : null] }));
};
